<template>
  <base-stat-item :metric="metric" label="Enquiry Via Form">
    <template v-slot:icon>
      <form-enquiry-icon></form-enquiry-icon>
    </template>
  </base-stat-item>
</template>
<script>
import BaseStatItem from './BaseStatItem.vue';
import FormEnquiryIcon from '../Icons/FormEnquiryIcon.vue';

export default {
  props: {
    metric: [String, Number],
  },
  components: {
    BaseStatItem,
    FormEnquiryIcon,
  },
};
</script>
